import { IApplicationState } from '../../types/redux';

export function getMinPriceForMeterFromDeveloperValue(state: IApplicationState): number | null {
  return Number(state.offersData?.newbuildingPromoSnippet?.newbuilding?.fromDevelopersRooms[0]?.minPrice2) || null;
}
